<app-modal-header *ngIf="activeUser$ | async">
  <div class="flex w-full items-center gap-2">
    <svg-icon
      class="w-8 text-theme-500"
      src="assets/icons/icon-library.svg"
      alt="'materiais-didaticos.titulo' | translate"
    ></svg-icon>

    <h1 class="text-sm font-semibold leading-tight text-gray-800">
      {{ 'materiais-didaticos.logo-titulo' | translate }}
      <br />
      <b class="text-lg text-black">{{ 'materiais-didaticos.logo-subtitulo' | translate }}</b>
    </h1>

    <hr app-modal-divider />

    <div class="flex w-full items-center justify-end">
      <button
        type="button"
        (click)="onOpenBookBlank()"
        app-icon-button
        class="mr-4 border border-gray-300 px-3 py-2 text-gray-400 hover:bg-gray-400 hover:text-white"
      >
        <svg-icon class="w-5" src="assets/icons/icon-link.svg"></svg-icon>
      </button>
      <ng-container *ngIf="data.anexos.length > 1">
        <button
          *ngIf="hasBookTeacher"
          app-button
          (click)="setBook()"
          [ngClass]="!isStudent ? 'bg-[#EA9150]' : 'bg-[#ea915038] hover:text-gray-400'"
          class="rounded-r-none px-4 py-2 text-white"
        >
          <svg-icon class="mr-2 w-4" src="assets/icons/icon-teacher.svg" alt=""></svg-icon>
          {{ 'materiais-didaticos.prof' | translate }}
        </button>
        <button
          *ngIf="hasBookStudent"
          (click)="setBook(true)"
          app-button
          [ngClass]="isStudent ? 'bg-[#003264]' : 'bg-[#00326420] hover:text-gray-400'"
          class="rounded-l-none px-4 py-2 text-white"
        >
          <svg-icon class="mr-2 w-5" src="assets/icons/icon-student.svg" alt=""></svg-icon>
          {{ 'materiais-didaticos.aluno' | translate }}
        </button>
      </ng-container>
    </div>
  </div>
</app-modal-header>
<div app-modal-content class="flex !p-0 max-md:h-full max-md:flex-col max-md:overflow-scroll">
  <div class="mt-[2px] h-[100vh]" [ngClass]="!data?.contents.length ? '!w-full' : 'md:w-9/12'">
    <iframe
      *ngIf="url() as url"
      width="100%"
      height="92%"
      frameborder="0"
      scrolling="no"
      marginheight="0"
      marginwidth="0"
      [src]="url + ('&p=' + page) + ('#p=' + page) | safe: 'resourceUrl'"
    >
    </iframe>
  </div>
  <div *ngIf="!!data?.contents.length" class="p-2 md:w-3/12">
    <app-element-summary [bookContent]="data" [showModal]="true" (page)="setPage($event)"></app-element-summary>
  </div>
</div>
